// Link and upload helpers for the Tiptap editor, kept apart from the controller so they
// can be tested without a DOM.

const HTTP_URL = /^https?:\/\/\S+$/i;

/** The only link targets the editor writes; the server-side safe-list agrees. */
export function isHttpUrl(url) {
	return HTTP_URL.test((url || "").trim());
}

/** Turns a DirectUpload failure into the line shown under the toolbar. */
export function uploadErrorMessage(error, labels) {
	const status = /Status: (\d{3})/.exec(String(error?.message || error || ""))?.[1];
	if (status === "422") return labels.upload_rejected;
	if (status === "401" || status === "404") return labels.upload_login;
	return labels.upload_failed;
}
